import { Postcode } from 'Input/Postcode';
import { Typography, Stack } from '@mui/material';
// import { Latitude } from 'Input/Latitude'
// import { Longitude } from 'Input/Longitude'

const Location = () => {
  return (<Stack spacing={1}>
    
      <Typography variant='body1' component='h1' textAlign='center'>
      Your farm's postcode is used to retrieve the local weather forecast.
      </Typography>

    <>
      <Postcode/>
    </>
  </Stack>);
}

export default Location;
